export const createQuestion = (params, body) => ({
  data: {
    id: 3,
    content: "<p>Hôm nay của bạn thế nào?</p>",
    image_url: null,
    score: 10,
    order: 2,
    type: "multiple",
    explanation: "123423423432",
    answers: [
      {
        id: 1,
        content: "Vui",
        image_url: null,
      },
      {
        id: 2,
        content: "Buồn",
        image_url: null,
      },
    ],
  },
  status: 200,
});

export const updateQuestion = (params, body) => ({
  data: {
    id: params.pk,
    content: body.content,
    image_url: null,
    score: Number(body.score),
    order: 2,
    type: body.type,
    explanation: "123423423432",
    answers: [
      {
        id: 1,
        content: body.answers[0].content,
        // is_correct: body.answers[0].is_correct,
        image_url: null,
      },
      {
        id: 2,
        content: "Buồn",
        image_url: null,
      },
    ],
  },
  status: 200,
});

export const getResult = (params, body) => ({
  data: {
    id: 21,
    timing: 0,
    total_score: 30,
    userQuiz: {
      id: 69,
      quiz_id: 21,
      status: "redo",
      score: 0,
    },
    questions: [
      {
        id: 17,
        score: 10,
        type: "multiple",
        order: 0,
        content: "<p>Oki</p>",
        answers: [
          {
            id: 56,
            content: "sdfs",
            image_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1676021119HwN9tP2bmfMqLND.jpg",
          },
          {
            id: 57,
            content: "sà",
            image_url: "http://d1j8r0kxyu9tj8.cloudfront.net/files/1676021127eMlnWdCIaubEqUc.jpg",
          },
        ],
        userAnswers: [
          {
            id: 208,
            answer_id: 56,
            question_id: 17,
            is_correct: true,
          },
        ],
        explanation: "123423423432",
        is_correct: 2,
      },
      {
        id: 22,
        score: 10,
        type: "single",
        order: 1,
        content: "<p>Hôm nay thế nào?</p>",
        answers: [
          {
            id: 62,
            content: "Vui",
            image_url: null,
          },
          {
            id: 63,
            content: "Buồn",
            image_url: null,
          },
        ],
        userAnswers: [
          {
            id: 209,
            answer_id: 63,
            question_id: 22,
            is_correct: false,
          },
        ],
        explanation: null,
        is_correct: 0,
      },
      {
        id: 33,
        score: 10,
        type: "single",
        order: 2,
        content: "<p>sadf</p>",
        answers: [
          {
            id: 97,
            content: "sc",
            image_url: null,
          },
          {
            id: 98,
            content: "dsa",
            image_url: null,
          },
        ],
        userAnswers: [
          {
            id: 210,
            answer_id: 98,
            question_id: 33,
            is_correct: false,
          },
        ],
        explanation: null,
        is_correct: 0,
      },
    ],
  },
  status: 1,
});
